import Calendar from "../../assets/icon/NewsIcons/MainAdmin/NewsCalendar3"
import Clock from "../../assets/icon/NewsIcons/MainAdmin/NewsClock3"
import Bell from "../../assets/icon/NewsIcons/MainAdmin/NewsBell"
import Down from "../../assets/icon/NewsIcons/MainAdmin/NewsDown3"
import { useState,useEffect } from "react"
import Cookies from 'universal-cookie';

const MainAdminTop = () => {
    const [currentTime, setCurrentTime] = useState("");
    const [currentDate, setCurrentDate] = useState("");
    const [name, setName] = useState("");
    useEffect(() => {
                      const cookies = new Cookies();
      // cookies.get('name') ? setName(cookies.get('name')) : setName("کاربر ");  
      // تابع برای گرفتن زمان و تاریخ
      const updateTime = () => {
        const now = new Date();
        const options = { timeZone: "Asia/Tehran", hour12: false };
        const timeFormatter = new Intl.DateTimeFormat("fa-IR", {
          ...options,
          hour: "2-digit",
          minute: "2-digit",
        });
        const dateFormatter = new Intl.DateTimeFormat("fa-IR", {
          ...options,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
  
        setCurrentTime(timeFormatter.format(now));
        setCurrentDate(dateFormatter.format(now));
      };
  
      // اجرای تابع و به‌روزرسانی هر ثانیه
      updateTime();
      const intervalId = setInterval(updateTime, 1000);
  
      // پاک کردن تایمر هنگام خروج از کامپوننت
      return () => clearInterval(intervalId);
    }, []);
  
    return(
        <div className="flex justify-between items-center w-full mb-[15px]">
            <div className="flex justify-start items-center">
                <div><Calendar/></div>
                <p className="text-[15px] font-IRANYekanBold text-mainColor2 px-[10px] border-l-[2px] border-mainColor2">
                {currentDate}
                </p>
                <div className="px-[10px]"><Clock/></div>
                <p className="text-[15px] font-IRANYekanBold text-mainColor2">
                {currentTime}
                </p>
            </div>
            {/* <div className="flex items-center">
                <button className="flex justify-center items-center w-[40px] h-[40px] bg-white rounded-full shadow-norm-shadow">
                    <div><Bell/></div>
                </button> */}
                {/* <button className="flex  items-center w-[178px] h-[40px] bg-white rounded-[10px] shadow-norm-shadow mr-[15px] px-[15px]"> */}
                    {/* <p className="text-[15px] font-IRANYekanBold text-mainColor2">{name}</p> */}
                    {/* <div><Down/></div> */}
                {/* </button> */}
            {/* </div> */}

        </div>
    )
}

export default MainAdminTop;